enum LogicRegistryErrors {
  ALREADY_REGISTERED = 'The feature is already registered',
  MISSING_FEATURE = 'There is no feature registered',
}

export class LogicRegistry {
  private registry: Map<object, object>;

  constructor() {
    this.registry = new Map();
  }

  public put(featureInterface: object, implementation: object): void {
    if (this.has(featureInterface)) {
      // @ts-ignore
      throw new Error(`${LogicRegistryErrors.ALREADY_REGISTERED}: ${featureInterface.name}`);
    }
    this.registry.set(featureInterface, implementation);
  }

  public get(featureInterface: object): object | void {
    if (!this.has(featureInterface)) {
      // @ts-ignore
      throw new Error(`${LogicRegistryErrors.MISSING_FEATURE} ${featureInterface.name}`);
    }

    return this.registry.get(featureInterface);
  }

  public has(featureInterface: object): boolean {
    return this.registry.has(featureInterface);
  }
}
